import type { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import { Account, AccountToken, type BaseAccount } from '@/types'
import { createSelectReceiveAccount } from '@/views/dashboard/receive/SelectReceiveAccount.vue'

export const receiveSelectAddressRoute = (params: {
  name: string
  path?: string
  onSelectAccount: (account: BaseAccount) => void
}): RouteRecordRaw => {
  return {
    name: params.name,
    path: params.path ?? 'receive/select-address',
    component: createSelectReceiveAccount(params.onSelectAccount),
    props: true,
  }
}

export const walletReceiveSelectAddressRoute = receiveSelectAddressRoute({
  name: 'wallet_receive_select_address',
  onSelectAccount(account) {
    if (account instanceof Account) {
      router.replace({
        name: 'wallet_receive_account_qrview',
        query: {
          accountId: account.id,
          accountTokenId: undefined,
        },
      })
    } else if (account instanceof AccountToken) {
      router.replace({
        name: 'wallet_receive_account_qrview',
        query: {
          accountId: undefined,
          accountTokenId: account.id,
        },
      })
    }
  },
})
export const nftReceiveSelectAddressRoute = receiveSelectAddressRoute({
  name: 'nft_receive_select_address',
  onSelectAccount(account) {
    if (account instanceof Account) {
      router.replace({
        name: 'nft_receive_account_qrview',
        query: {
          accountId: account.id,
          accountTokenId: undefined,
        },
      })
    } else if (account instanceof AccountToken) {
      router.replace({
        name: 'nft_receive_account_qrview',
        query: {
          accountId: undefined,
          accountTokenId: account.id,
        },
      })
    }
  },
})

export const receiveQrViewRoute = (
  name: string,
  path?: string,
): RouteRecordRaw => {
  return {
    name,
    path: path ?? 'receive/qrview',
    component: () => import('@/views/dashboard/receive/QRViewer.vue'),
    props: true,
  }
}
